import React from "react";
import { Avatar, Box, ButtonBase, Typography, useTheme } from "@mui/material";
import { profileCardSx } from "./components/InvestorWorkspace";
import { getPersonPortraitImageProps } from "./personPortrait";

export interface CongressionalMember {
  name: string;
  fmpName: string;
  imageUrl: string;
  isSenate: boolean;
}
interface CongressionalCardProps {
  member: CongressionalMember;
  onClick?: (member: CongressionalMember) => void;
}
const CongressionalCard = ({ member, onClick }: CongressionalCardProps) => {
  const theme = useTheme();
  return (
    <ButtonBase
      onClick={() => onClick?.(member)}
      aria-label={`View ${member.name}'s disclosures`}
      sx={{
        ...profileCardSx(theme),
        flexDirection: "row",
        alignItems: "center",
        gap: 2,
        py: 2.5,
      }}
    >
      <Avatar
        {...getPersonPortraitImageProps(member.imageUrl, 64, 72)}
        alt=""
        sx={{ width: 64, height: 72, borderRadius: 2 }}
      >
        {member.name[0]}
      </Avatar>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "0.625rem",
            letterSpacing: "0.06em",
            textTransform: "uppercase",
            color: "primary.main",
            mb: 0.75,
          }}
        >
          {member.isSenate ? "Senate" : "House"}
        </Typography>
        <Typography
          component="h2"
          sx={{ fontSize: "1rem", fontWeight: 600, letterSpacing: "-0.02em" }}
        >
          {member.name}
        </Typography>
        <Typography
          sx={{ fontSize: "0.75rem", color: "text.secondary", mt: 0.75 }}
        >
          Trading disclosures
        </Typography>
      </Box>
    </ButtonBase>
  );
};
export default CongressionalCard;
